<script setup lang="ts">
import router from '@/router'
import { useUserInfoStore } from '@/stores/modules/user'
import { ref } from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import RecursiveMenu from '../../components/menu/RecursiveMenu.vue'

const userInfo = useUserInfoStore()
const menus = userInfo.user.menus

const route = useRoute()
// 默认选中
const defaultActive = ref(route.path)
// 监听路由变化
onBeforeRouteUpdate((to) => {
  defaultActive.value = to.path
})
const handleSelect = (e: any) => {
  emit('select', e)
  router.push(e)
}

const emit = defineEmits<{
  (e: 'select', path: string): void
}>()
</script>
<template>
  <el-menu
    :default-active="defaultActive"
    @select="handleSelect"
    :unique-opened="true"
    class="side-menu"
    :collapse="userInfo.collapse"
  >
    <RecursiveMenu :menu-data="menus" />
  </el-menu>
</template>
<style scoped lang="scss">
.side-menu:not(.el-menu--collapse) {
  @apply w-[200px];
}
.side-menu {
  @apply grow overflow-x-hidden;
}
</style>
